
import React from 'react';
import './policies.css';

function GoverningLawJurisdiction() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Governing Law & Jurisdiction</h1>

        <p className="last-updated">
          Last Updated: January 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            This page outlines the governing law and jurisdiction applicable to
            the use of the Mr White website, mobile application, and services.
          </p>
        </div>

        <div className="policy-section">
          <h2>Applicable Law</h2>

          <p>
            Our website and its terms, policies, and use shall be governed by
            and construed in accordance with the laws of the
            <strong> United Arab Emirates (UAE)</strong>.
          </p>
        </div>

        <div className="policy-section">
          <h2>Jurisdiction</h2>

          <p>
            Any disputes, claims, or controversies arising out of or relating
            to the use of this website, mobile application, or any services
            provided by Mr White shall be subject to the exclusive jurisdiction
            of the competent courts of the
            <strong> United Arab Emirates (UAE)</strong>.
          </p>
        </div>

        <div className="policy-section">
          <h2>Contact Us</h2>

          <p>
            If you have any questions regarding this Governing Law &
            Jurisdiction Policy, please contact us:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default GoverningLawJurisdiction;
